import LangEnum from '../../../lang/LangEnum';
import snackbarStore from '../../../stores/Snackbar.store';
import { createLinkToDownloadBlob } from '../../../utils/createLinkToDownload';
import { onlineOrderActionsRepository } from '../../orders/repositories/orderActions.repository';
import { OrderActionsRepositoryParams } from '../../orders/repositories/orderActions.repository.types';
import { OfflineOrderCsvBuilder } from '../builders/offlineOrderCsv/OfflineOrderCsv.builder';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { notImplementedInOfflineError } from './utils/repository.offlineAdapters.utils';

const { handleMessage } = snackbarStore;

export const orderActionsRepositoryOfflineAdapters = ({
  orderId,
  translate,
}: OrderActionsRepositoryParams): ReturnType<typeof onlineOrderActionsRepository> => ({
  exportCsv: async (filename) => {
    try {
      const offlineOrder = await offlineOrdersRepository.getById(orderId);

      if (!offlineOrder) {
        throw new Error('order not found');
      }

      const offlineOrderCsvBuilder = new OfflineOrderCsvBuilder([offlineOrder]);
      const csvData = offlineOrderCsvBuilder.build();

      createLinkToDownloadBlob({
        filename,
        archiveType: 'csv',
        data: csvData,
      });
    } catch (error) {
      console.error('exportCsv', {
        error,
        orderId,
      });

      handleMessage({
        type: 'error',
        message: translate(LangEnum.SNACKBAR_ERROR_DOWNLOADING_ORDER_CSV),
      });
    }
  },
  downloadMedias: () => {
    throw new Error('not implemented');
  },
  splitOrder: async () => {
    throw new Error('not implemented');
  },
  sync: () => notImplementedInOfflineError('sync'),
});
